import { environment } from 'src/environments/environment';
import { HttpService } from '@sdbn/appclient';
import { UmbrueckungDetails } from '../model/umbrueckung-details';
import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { ServiceResponse } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { ResponseMessage } from '@sdbn/appclient';
import { TransportStationAssignment } from 'src/tmc-yard/widgets/control/sac-client/model/sac-client.model';


@Component({
  selector: 'app-complete-umbrueckung-dialog',
  templateUrl: './complete-umbrueckung-dialog.component.html',
  styleUrls: ['./complete-umbrueckung-dialog.component.scss']
})
export class CompleteUmbrueckungDialogComponent implements OnInit {

  loading = false;

  responseMessages: ResponseMessage[];

  details: UmbrueckungDetails;

  constructor(
    private httpService: HttpService,
    public dialogRef: MatDialogRef<CompleteUmbrueckungDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translationService: TranslationService
  ) {
    this.details = data.details;
  }

  ngOnInit() {
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  public cancel() {
    this.loading = true;
    this.responseMessages = [];

    const assignment = new TransportStationAssignment();
    assignment.transport = { id: this.details.id };
    assignment.station = { id: this.details.currentStationId };

    this.httpService.postWithContext<ServiceResponse>(environment.transportUmbrueckungEndpoint + '/cancel', assignment).subscribe(
      response => {

        if (response.status !== ResponseStatus.SUCCESS) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.loading = false;
      }, error => {
        console.log('Unexpected error' + error);
        this.loading = false;
      }
    );
  }

  public complete() {

    this.loading = true;

    this.responseMessages = [];

    const assignment = new TransportStationAssignment();
    assignment.transport = { id: this.details.id };
    assignment.station = { id: this.details.currentStationId };

    this.httpService.postWithContext<ServiceResponse>(environment.transportUmbrueckungEndpoint + '/complete', assignment).subscribe(
      response => {

        if (response.status !== ResponseStatus.SUCCESS) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.loading = false;
      }, error => {
        console.log('Unexpected error' + error);
        this.loading = false;
      }
    );
  }
}

